import Websocket from "ws";
import { IS_BROWSER_MAIN_THREAD } from "../consts.js";

export class WebSocketApi {
  constructor(url, auth) {
    this.websocket = null;
    this.connected = false;
    this.queue = [];
    this.url = url;
    this.auth = auth;
    this.heartBeatTimeStemp = 10000000000000;
    this.ALLOWED_HEART_BEAT_DELEY = 12000;
    this.firstHeartBeat = true;
    this.reload = true;
    this.isBrowser = IS_BROWSER_MAIN_THREAD;
  }

  async addSubscription(app_id) {
    //console.log("Added new subscription: app_id - ", app_id);

    const token = await this.auth.getToken();
    const subscription = `token=${token}/~/app_id=${app_id}`;

    if (this.connected) {
      this.websocket.send(subscription);
    }

    this.queue.push(app_id);
  }

  async onOpen() {
    this.reload = true;
    console.log("websocket opened");

    this.connected = true;
    const token = await this.auth.getToken();

    this.queue.forEach((queue) => {
      const subscription = `token=${token}/~/app_id=${queue}`;
      this.websocket.send(subscription);
    });
  }

  onError(error) {
    console.log("websocket error: ", error);

    this.websocket.close();
  }

  onClose() {
    console.log("websocket close");

    this.connected = false;
    try {
      this.initWebSocket(this.onMassageHandler, this.refreshAppsHandler);
    } catch (error) {
      console.log(error);
    }
  }

  async onMessage(event) {
    const message = this.isBrowser ? event.data : event
    if (message.match(/HeartBeat/)) {
      const hartBeatDelay = new Date().getTime() - this.heartBeatTimeStemp;

      if (this.ALLOWED_HEART_BEAT_DELEY < hartBeatDelay) {
        await this.onConnectionLost();
      } else {
        this.websocket.send("HeartBeat");
        this.heartBeatTimeStemp = new Date().getTime();
      }
    }

    if (this.firstHeartBeat) {
      this.connectionChecker();
      this.firstHeartBeat = false;
    }

    if (message.match(/[{}]/)) {
      let incomeMessage = JSON.parse(message);
      const token = await this.auth.getToken();

      //-- We don't want to update storage of user who initieted the update. That is why we check if token from websocket is not the same as users token.
      if (incomeMessage.token != token) {
        this.onMassageHandler(incomeMessage);
      }
    }
  }

  initWebSocket(onMassageHandler, refreshAppsHandler) {
    this.onMassageHandler = onMassageHandler;
    this.refreshAppsHandler = refreshAppsHandler
    if (this.isBrowser) {
      this.websocket = new WebSocket(this.url);
      this.websocket.onopen = this.onOpen.bind(this);

      this.websocket.onerror = this.onError.bind(this);

      this.websocket.onclose = this.onClose.bind(this);

      this.websocket.onmessage = this.onMessage.bind(this);
    } else {
      this.websocket = new Websocket(this.url);
      this.websocket.on("open", this.onOpen);

      this.websocket.on("error", this.onError);

      this.websocket.on("close", this.onClose);

      this.websocket.on("message", this.onMessage);
    }

    console.log("websocket initialized");
  }

  connectionChecker() {
    setInterval(async () => {
      let hartBeatDelay = new Date().getTime() - this.heartBeatTimeStemp;
      // console.log(hartBeatDelay, this.ALLOWED_HEART_BEAT_DELEY, "interval");
      if (this.ALLOWED_HEART_BEAT_DELEY < hartBeatDelay) {
        await this.onConnectionLost();
      }
    }, 1000);
  }

  async onConnectionLost() {
    try {
      await this.auth.getVersion();
      if (this.reload) {
        this.reload = false;
        console.log("Connected");
        this.heartBeatTimeStemp = 10000000000000;

        this.websocket.close();
        // Should be uncommented after websocket is fixed
        // this.refreshAppsHandler(this.queue);
      }
    } catch (error) {
      console.log(error);
    }
  }
}
